// extracted by mini-css-extract-plugin
module.exports = {"container":"App-module__container___1cmbG","header":"App-module__header___1vhb7","logo":"App-module__logo___1pj8g","body":"App-module__body___3aXvK"};